import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-education-mgr",
  "use": "icon-education-mgr-usage",
  "viewBox": "0 0 16 11.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 11.6\" id=\"icon-education-mgr\"><defs></defs><path class=\"a\" d=\"M13.6,6.831l1.976-.984A1.4,1.4,0,0,1,17.6,7.1v5.066a1.4,1.4,0,0,1-2.047,1.241L13.6,12.39v.81a2.2,2.2,0,0,1-2.2,2.2H3.8a2.2,2.2,0,0,1-2.2-2.2V6A2.2,2.2,0,0,1,3.8,3.8h7.6A2.2,2.2,0,0,1,13.6,6Zm0,1.341v2.864l2.508,1.308a.2.2,0,0,0,.292-.177V7.1a.2.2,0,0,0-.289-.179ZM12.4,13.2V6a1,1,0,0,0-1-1H3.8a1,1,0,0,0-1,1v7.2a1,1,0,0,0,1,1h7.6A1,1,0,0,0,12.4,13.2Zm-7-4.4A1.2,1.2,0,1,1,6.6,7.6,1.206,1.206,0,0,1,5.4,8.8Z\" transform=\"translate(-1.6 -3.8)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/education-mgr.svg
// module id = 8OCF
// module chunks = 115